import { render, staticRenderFns } from "./reportBigTb.vue?vue&type=template&id=1845fa05&scoped=true"
import script from "./reportBigTb.vue?vue&type=script&lang=js"
export * from "./reportBigTb.vue?vue&type=script&lang=js"
import style0 from "./reportBigTb.vue?vue&type=style&index=0&id=1845fa05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1845fa05",
  null
  
)

export default component.exports